// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createKnowledgeBaseRequestToJson, createKnowledgeBaseResponseFromJson, createKnowledgeSourceRequestToJson, createKnowledgeSourceResponseFromJson, deleteAppRequestToJson, deleteKnowledgeBaseRequestToJson, deleteKnowledgeSourceRequestToJson, dismissKnowledgeSourceTrainingErrorRequestToJson, getAppRequestToJson, getAppResponseFromJson, getKnowledgeBaseRequestToJson, getKnowledgeBaseResponseFromJson, getKnowledgeSourceRequestToJson, getKnowledgeSourceResponseFromJson, listAllAppsForKnowledgeSourceRequestToJson, listAllAppsForKnowledgeSourceResponseFromJson, listAllKnowledgeSourcesForAppRequestToJson, listAllKnowledgeSourcesForAppResponseFromJson, listAppsRequestToJson, listAppsResponseFromJson, listKnowledgeBasesRequestToJson, listKnowledgeBasesResponseFromJson, listKnowledgeSourcesRequestToJson, listKnowledgeSourcesResponseFromJson, removeKnowledgeBaseFromAppsInNamespaceRequestToJson, removeKnowledgeBaseFromAppsInNamespaceResponseFromJson, setAppsForKnowledgeSourceRequestToJson, tuneAIModelRequestToJson, updateKnowledgeBaseRequestToJson, updateKnowledgeSourceRequestToJson, upsertAppRequestToJson, upsertKnowledgeForAppRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createKnowledgeBase(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeBase', createKnowledgeBaseRequestToJson(request));
    return createKnowledgeBaseResponseFromJson(raw);
}
export function createKnowledgeBase$(request, options) {
    return defer(() => createKnowledgeBaseWithTransport$(getGlobalTransport(), request, options));
}
export function createKnowledgeBaseWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeBase', createKnowledgeBaseRequestToJson(request), options)
        .pipe(map(resp => createKnowledgeBaseResponseFromJson(resp)));
}
export async function getKnowledgeBase(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeBase', getKnowledgeBaseRequestToJson(request));
    return getKnowledgeBaseResponseFromJson(raw);
}
export function getKnowledgeBase$(request, options) {
    return defer(() => getKnowledgeBaseWithTransport$(getGlobalTransport(), request, options));
}
export function getKnowledgeBaseWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeBase', getKnowledgeBaseRequestToJson(request), options)
        .pipe(map(resp => getKnowledgeBaseResponseFromJson(resp)));
}
export async function updateKnowledgeBase(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeBase', updateKnowledgeBaseRequestToJson(request));
}
export function updateKnowledgeBase$(request, options) {
    return defer(() => updateKnowledgeBaseWithTransport$(getGlobalTransport(), request, options));
}
export function updateKnowledgeBaseWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeBase', updateKnowledgeBaseRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function deleteKnowledgeBase(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeBase', deleteKnowledgeBaseRequestToJson(request));
}
export function deleteKnowledgeBase$(request, options) {
    return defer(() => deleteKnowledgeBaseWithTransport$(getGlobalTransport(), request, options));
}
export function deleteKnowledgeBaseWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeBase', deleteKnowledgeBaseRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listKnowledgeBases(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeBases', listKnowledgeBasesRequestToJson(request));
    return listKnowledgeBasesResponseFromJson(raw);
}
export function listKnowledgeBases$(request, options) {
    return defer(() => listKnowledgeBasesWithTransport$(getGlobalTransport(), request, options));
}
export function listKnowledgeBasesWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeBases', listKnowledgeBasesRequestToJson(request), options)
        .pipe(map(resp => listKnowledgeBasesResponseFromJson(resp)));
}
export async function createKnowledgeSource(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeSource', createKnowledgeSourceRequestToJson(request));
    return createKnowledgeSourceResponseFromJson(raw);
}
export function createKnowledgeSource$(request, options) {
    return defer(() => createKnowledgeSourceWithTransport$(getGlobalTransport(), request, options));
}
export function createKnowledgeSourceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeSource', createKnowledgeSourceRequestToJson(request), options)
        .pipe(map(resp => createKnowledgeSourceResponseFromJson(resp)));
}
export async function getKnowledgeSource(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeSource', getKnowledgeSourceRequestToJson(request));
    return getKnowledgeSourceResponseFromJson(raw);
}
export function getKnowledgeSource$(request, options) {
    return defer(() => getKnowledgeSourceWithTransport$(getGlobalTransport(), request, options));
}
export function getKnowledgeSourceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeSource', getKnowledgeSourceRequestToJson(request), options)
        .pipe(map(resp => getKnowledgeSourceResponseFromJson(resp)));
}
export async function updateKnowledgeSource(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeSource', updateKnowledgeSourceRequestToJson(request));
}
export function updateKnowledgeSource$(request, options) {
    return defer(() => updateKnowledgeSourceWithTransport$(getGlobalTransport(), request, options));
}
export function updateKnowledgeSourceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeSource', updateKnowledgeSourceRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function deleteKnowledgeSource(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeSource', deleteKnowledgeSourceRequestToJson(request));
}
export function deleteKnowledgeSource$(request, options) {
    return defer(() => deleteKnowledgeSourceWithTransport$(getGlobalTransport(), request, options));
}
export function deleteKnowledgeSourceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeSource', deleteKnowledgeSourceRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listKnowledgeSources(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeSources', listKnowledgeSourcesRequestToJson(request));
    return listKnowledgeSourcesResponseFromJson(raw);
}
export function listKnowledgeSources$(request, options) {
    return defer(() => listKnowledgeSourcesWithTransport$(getGlobalTransport(), request, options));
}
export function listKnowledgeSourcesWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeSources', listKnowledgeSourcesRequestToJson(request), options)
        .pipe(map(resp => listKnowledgeSourcesResponseFromJson(resp)));
}
export async function upsertApp(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/UpsertApp', upsertAppRequestToJson(request));
}
export function upsertApp$(request, options) {
    return defer(() => upsertAppWithTransport$(getGlobalTransport(), request, options));
}
export function upsertAppWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/UpsertApp', upsertAppRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getApp(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/GetApp', getAppRequestToJson(request));
    return getAppResponseFromJson(raw);
}
export function getApp$(request, options) {
    return defer(() => getAppWithTransport$(getGlobalTransport(), request, options));
}
export function getAppWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/GetApp', getAppRequestToJson(request), options)
        .pipe(map(resp => getAppResponseFromJson(resp)));
}
export async function deleteApp(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/DeleteApp', deleteAppRequestToJson(request));
}
export function deleteApp$(request, options) {
    return defer(() => deleteAppWithTransport$(getGlobalTransport(), request, options));
}
export function deleteAppWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/DeleteApp', deleteAppRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listApps(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/ListApps', listAppsRequestToJson(request));
    return listAppsResponseFromJson(raw);
}
export function listApps$(request, options) {
    return defer(() => listAppsWithTransport$(getGlobalTransport(), request, options));
}
export function listAppsWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/ListApps', listAppsRequestToJson(request), options)
        .pipe(map(resp => listAppsResponseFromJson(resp)));
}
export async function listAllKnowledgeSourcesForApp(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/ListAllKnowledgeSourcesForApp', listAllKnowledgeSourcesForAppRequestToJson(request));
    return listAllKnowledgeSourcesForAppResponseFromJson(raw);
}
export function listAllKnowledgeSourcesForApp$(request, options) {
    return defer(() => listAllKnowledgeSourcesForAppWithTransport$(getGlobalTransport(), request, options));
}
export function listAllKnowledgeSourcesForAppWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/ListAllKnowledgeSourcesForApp', listAllKnowledgeSourcesForAppRequestToJson(request), options)
        .pipe(map(resp => listAllKnowledgeSourcesForAppResponseFromJson(resp)));
}
export async function listAllAppsForKnowledgeSource(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/ListAllAppsForKnowledgeSource', listAllAppsForKnowledgeSourceRequestToJson(request));
    return listAllAppsForKnowledgeSourceResponseFromJson(raw);
}
export function listAllAppsForKnowledgeSource$(request, options) {
    return defer(() => listAllAppsForKnowledgeSourceWithTransport$(getGlobalTransport(), request, options));
}
export function listAllAppsForKnowledgeSourceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/ListAllAppsForKnowledgeSource', listAllAppsForKnowledgeSourceRequestToJson(request), options)
        .pipe(map(resp => listAllAppsForKnowledgeSourceResponseFromJson(resp)));
}
export async function upsertKnowledgeForApp(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/UpsertKnowledgeForApp', upsertKnowledgeForAppRequestToJson(request));
}
export function upsertKnowledgeForApp$(request, options) {
    return defer(() => upsertKnowledgeForAppWithTransport$(getGlobalTransport(), request, options));
}
export function upsertKnowledgeForAppWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/UpsertKnowledgeForApp', upsertKnowledgeForAppRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function setAppsForKnowledgeSource(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/SetAppsForKnowledgeSource', setAppsForKnowledgeSourceRequestToJson(request));
}
export function setAppsForKnowledgeSource$(request, options) {
    return defer(() => setAppsForKnowledgeSourceWithTransport$(getGlobalTransport(), request, options));
}
export function setAppsForKnowledgeSourceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/SetAppsForKnowledgeSource', setAppsForKnowledgeSourceRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function tuneAIModel(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/TuneAIModel', tuneAIModelRequestToJson(request));
}
export function tuneAIModel$(request, options) {
    return defer(() => tuneAIModelWithTransport$(getGlobalTransport(), request, options));
}
export function tuneAIModelWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/TuneAIModel', tuneAIModelRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function dismissKnowledgeSourceTrainingError(request) {
    await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/DismissKnowledgeSourceTrainingError', dismissKnowledgeSourceTrainingErrorRequestToJson(request));
}
export function dismissKnowledgeSourceTrainingError$(request, options) {
    return defer(() => dismissKnowledgeSourceTrainingErrorWithTransport$(getGlobalTransport(), request, options));
}
export function dismissKnowledgeSourceTrainingErrorWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/DismissKnowledgeSourceTrainingError', dismissKnowledgeSourceTrainingErrorRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function removeKnowledgeBaseFromAppsInNamespace(request) {
    const raw = await fetchRpc('embeddings.v1alpha1.KnowledgeBaseService/RemoveKnowledgeBaseFromAppsInNamespace', removeKnowledgeBaseFromAppsInNamespaceRequestToJson(request));
    return removeKnowledgeBaseFromAppsInNamespaceResponseFromJson(raw);
}
export function removeKnowledgeBaseFromAppsInNamespace$(request, options) {
    return defer(() => removeKnowledgeBaseFromAppsInNamespaceWithTransport$(getGlobalTransport(), request, options));
}
export function removeKnowledgeBaseFromAppsInNamespaceWithTransport$(transport, request, options) {
    return transport
        .post('embeddings.v1alpha1.KnowledgeBaseService/RemoveKnowledgeBaseFromAppsInNamespace', removeKnowledgeBaseFromAppsInNamespaceRequestToJson(request), options)
        .pipe(map(resp => removeKnowledgeBaseFromAppsInNamespaceResponseFromJson(resp)));
}
